import { menu } from './menu';
import { router } from './router';

export const Pujcovna = {
	menu,
	router,
};
